import axios from 'axios';

export default {
  getInstallations({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/installation/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertInstallations', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editInstallation({ commit, state }, { installation, event }) {
    return new Promise((resolve, reject) => {
      commit('editInstallationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/installation/edit`,
        params: installation,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editInstallationRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editInstallationRequestError', err);
          reject(err);
        });
    });
  },
  deleteInstallation({ commit, state }, installationId) {
    return new Promise((resolve, reject) => {
      commit('deleteInstallationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/installation/destroy`,
        params: { id: installationId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteInstallationRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteInstallationRequestError', err);
          reject(err);
        });
    });
  }
};
